/**
 * KnowledgebaseSort
 */
export enum KnowledgebaseSort {
    PREDEFINED = 'predefined',
    IMPORTANCE = 'importance',
    ALPHABETICAL = 'alphabetical',
    RECENT = 'recent'
}
